module.exports = __webpack_public_path__ + "img/lifestyle.7fbdd86b.png";